export default __webpack_public_path__ + "static/media/hand-raised.7c899f78.png";